module.exports = __webpack_public_path__ + "img/万寿竹.f887e910.jpg";